/**
 * Raised when the user dismissed the native full-screen scanner without scanning
 * anything (back/close button).
 *
 * Cancelling is a normal user action, not a failure: surfacing it as a distinct
 * error type lets the camera scanner service simply close its own UI state
 * instead of reporting an error and showing the "camera access denied" toast.
 */
export class ScanCancelledError extends Error {
  constructor(public readonly originalError?: unknown) {
    super('Barcode scan was cancelled by the user');
    this.name = 'ScanCancelledError';

    // Preserve prototype chain across the TS down-level emit so that
    // `error instanceof ScanCancelledError` works reliably at consumer sites.
    Object.setPrototypeOf(this, ScanCancelledError.prototype);
  }
}
